import { Folder, Star } from '@audio-network/componentlibrary/icons'

import ProjectList from '../ProjectList/ProjectList'
import SidebarNav from '../SidebarNav/SidebarNav'
import SidebarNavItem from '../SidebarNavItem/SidebarNavItem'
import { sendAnalytics } from '@audio-network/analytics'
import styles from './YourLibrary.module.css'
import { useTranslation } from 'next-i18next'

const YourLibrary = (props): JSX.Element => {
	const handleClick = (noun: string): void => {
		sendAnalytics({
			noun,
			pastTenseVerb: 'Clicked',
			eventParameters: {
				Location: 'Music App Navigation',
			},
		})
	}
	const { t } = useTranslation(['navigation'])

	return (
		<>
			<SidebarNav
				aria-label={t('your-library')}
				className={styles.yourLibrary}
				{...props}
			>
				<SidebarNavItem
					href="/favourites"
					onClick={() => handleClick('Favourites')}
					startIcon={<Star />}
					content={t('favourites')}
				/>

				<SidebarNavItem
					href="/project/all"
					onClick={() => handleClick('Projects')}
					startIcon={<Folder />}
					content={t('projects')}
				/>
			</SidebarNav>
			<ProjectList />
		</>
	)
}

export default YourLibrary
